// ⚠️ FICHIER GÉNÉRÉ — ne pas éditer ici. Source : shared/ui/ · régénérer avec `bash shared/sync.sh`
'use client';
/**
 * Le pied d'actions d'une fenêtre ou d'un formulaire. Règles : `shared/docs/UI-CONVENTIONS.md`.
 *
 *     [ secondaires… ]  [ Annuler ]  [ Action principale ]      → fin de ligne
 *
 * L'ordre n'est pas une convention à respecter : il est CONSTRUIT par
 * `ordonnerActions` (piedActionsOrdre.ts), et les types interdisent de faire de
 * la principale autre chose qu'un bouton plein (ou `danger` pour une suppression).
 *
 * `justify-content: flex-end` suit le sens d'écriture : fin de ligne en LTR comme en RTL,
 * sans propriété gauche/droite.
 *
 * Pas de confirmation intégrée : « Supprimer » passe par la confirmation de l'application.
 */
import React from 'react';
import { Bouton } from './Bouton';
import { ordonnerActions, type EntreesPied } from './piedActionsOrdre';

export type PiedActionsProps = EntreesPied & {
  /** Taille commune à tous les boutons du pied. `md` par défaut. */
  taille?: 'md' | 'sm';
  style?: React.CSSProperties;
};

export function PiedActions({ taille = 'md', style, ...entrees }: PiedActionsProps) {
  const actions = ordonnerActions(entrees);
  if (actions.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end', gap: 8, ...style }}>
      {actions.map((a) => (
        a.role === 'principale' ? (
          <Bouton
            key={a.role} variante={a.variante} taille={taille} type={a.type} onClick={a.onClick}
            chargement={a.chargement} libelleChargement={a.libelleChargement} disabled={a.disabled} title={a.title}
          >
            {a.libelle}
          </Bouton>
        ) : (
          <Bouton key={`${a.role}-${a.libelle}`} variante={a.variante} taille={taille} onClick={a.onClick} disabled={a.disabled} title={a.title}>
            {a.libelle}
          </Bouton>
        )
      ))}
    </div>
  );
}
